<template>
    <div class="container">
        <v-title :lineage="[{'Rules Engine':'rules-engine'}]">
            System Events
        </v-title>
        <div class="tile">
            <div class="tile-content">
                <event-list :events="systemEvents"/>
            </div>
        </div>
    </div>
</template>

<script>
    import compare from '@/common/helpers/compare';
    import EventModel from '@/common/models/rules/event-model';
    import vTitle from '@/components/v-title';
    import LoadStateMixin from '@/mixins/load-state-mixin';
    import EventList from './components/index/event-list';

    export default {
        name: 'system-events',
        mixins: [LoadStateMixin],
        components: {vTitle, EventList},
        data() {
            return {
                systemEvents: [],
            };
        },
        methods: {
            async fetchData() {
                const params = {limit: 50, offset: 0};
                const response = await this.$api(({events}) => events.getAll(params));
                const {items} = response.getJSON();
                this.systemEvents = items
                    // Filter only defined events.
                    .filter(({fields: {eventType}}) => EventModel.Specs[eventType] !== undefined)
                    .map(item => new EventModel(item.fields))
                    // Alphabetical sort by event type
                    .sort((a, b) => compare.values(a.eventType, b.eventType));
            },
        },
    };
</script>
